import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION1: PdfComponent = {
  type: 'section',
  id: 's1s1',
  title: '1. Definitions',
  content: [
    {
      type: 'altText',
      id: 's1s1heading',
      content: [
        'For the purposes of this Schedule, the following terms shall have the following meanings:',
      ],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 's1s1bullets',
      bulletType: 'dot',
      content: [
        {
          copy: {
            type: 'altText',
            id: '1_1pi',
            content: [
              'Personal Information:',
              'Personal Data that is provided or otherwise made available to the Data Controllers by or on behalf of a Data Controller in connection with this Agreement;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1_1pr',
            content: [
              'Processing:',
              ' Has the meaning given under the Data Protection Act 2018 (and Process, Processed and Processes shall be construed accordingly);',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1_1controller',
            content: [
              'Controller, Processor, Personal Data, Personal Data Breach, Data Subject and Joint Controller: ',
              ' Have the meanings given to them in the Data Protection Act 2018 and UK GDPR;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1_1reg',
            content: [
              'Regulation:',
              ' The General Data Protection Regulation (EU) 2016/679;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1_1personnel',
            content: [
              'Personnel:',
              ' All staff, contractors, employees, agents, subcontractors and sub-processors of the relevant party;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1_1key',
            content: [
              'Key Data Protection Representatives:',
              ' The persons set out in or replaced pursuant to paragraph 9 of this Schedule;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1_1fair',
            content: [
              'Fair Processing Notice:',
              ' A fair processing notice substantially in the form set out at paragraph 7.1;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1_1reg',
            content: [
              'Regulator:',
              ' Any person having regulatory or supervisory authority over (a) all or any part of the Processing of the Personal Information, or (b) the business of either party from time to time.',
            ],
          },
        },
      ],
      prefix: '1',
    },
  ],
};
